<template>
  <div
    class="label-input-field label-input-field--glass"
    :class="[
      {
        'label-input-field--flex': flex,
        'label-input-field--error': hasError,
        'label-input-field--no-label': hideLabel,
      },
      customClass,
    ]"
  >
    <span v-if="!hideLabel" :id="labelId" class="label-input-field__label">
      {{ label }}<span v-if="required" class="label-input-field__required" aria-hidden="true">*</span>
    </span>
    <div class="label-input-field__control">
      <input
        :id="inputId"
        :value="modelValue"
        class="label-input-field__input"
        :type="type"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :readonly="readonly"
        :aria-labelledby="hideLabel ? undefined : labelId"
        :aria-label="hideLabel ? resolvedAriaLabel : undefined"
        :aria-invalid="hasError ? 'true' : 'false'"
        :autocomplete="autocomplete"
        :pattern="pattern || undefined"
        @input="onInput"
        @keydown.enter.prevent="$emit('enter', $event)"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
      />
    </div>
    <div v-if="$slots.default" class="label-input-field__messages">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelInputField',
  props: {
    label: {
      type: String,
      default: '',
    },
    /** When true, hides the visible label (use `label` or `ariaLabel` for accessibility). */
    hideLabel: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    pattern: {
      type: String,
      default: '',
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['update:modelValue', 'input', 'blur', 'enter', 'focus'],
  computed: {
    labelId() {
      return `${this.inputId}-label`;
    },
    resolvedAriaLabel() {
      return this.ariaLabel || this.label || 'Input';
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
  },
};
</script>

<style src="../styles/LabelInputField.css"></style>
